import { createEffect, createSignal, JSX, onCleanup, Show } from "solid-js";

import UPromise from "@repo/utils/UPromise";

import Spinner from "../loaders/Spinner";

declare namespace ContinuousScroll {
  type Props = {
    class?: string;
    next(): UPromise.Maybe<{ done: boolean }>;
    children: JSX.Element;
  };
}

function ContinuousScroll({
  class: className,
  next,
  children,
}: D<ContinuousScroll.Props>) {
  const [done, setDone] = createSignal(false);
  const [loading, setLoading] = createSignal(false);
  const [isIntersecting, setIsIntersecting] = createSignal(true);

  createEffect(async () => {
    if (isIntersecting() && !loading() && !done()) {
      setLoading(true);
      setDone((await next()).done);
      requestAnimationFrame(() => setLoading(false));
    }
  });

  return (
    <div class={className}>
      {children}
      <div
        ref={(el) => {
          const observer = new IntersectionObserver(async ([entry]) => {
            setIsIntersecting(entry?.isIntersecting ?? false);
          });
          observer.observe(el);
          onCleanup(() => observer.disconnect());
        }}
      >
        <Show when={loading()}>
          <Spinner.Common />
        </Show>
      </div>
    </div>
  );
}

export default ContinuousScroll;
